/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, explanation: NonNullable<unknown> }} Special_Txns_ExplanationInputs */



/**
* | output |
* | --- |
* | "Exact count: {value}<br /><br />{explanation}" |
*
* @param {Special_Txns_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const special_txns_explanation = /** @type {((inputs: Special_Txns_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Special_Txns_ExplanationInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Exact count: ${i?.value}<br /><br />${i?.explanation}`)
});